import EnumDataSource from "../utils/enum-data-source.util";

export const PROMPT_TYPE_TEXT_TEMPLATE = 1;
export const PROMPT_TYPE_CHART_NOTE = 2;
export const PROMPT_TYPE_REPORT = 3;
export const PROMPT_TYPE_SCRIBE_CONTEXT = 4;

const promptTypes = {
  [PROMPT_TYPE_TEXT_TEMPLATE]: "Text Template",
  [PROMPT_TYPE_CHART_NOTE]: "Chart Note",
  [PROMPT_TYPE_REPORT]: "Report",
  [PROMPT_TYPE_SCRIBE_CONTEXT]: "Scribe Context",
};

export const PROMPT_TYPES = new EnumDataSource(promptTypes);
